import { Button } from '@efexteam/components';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { logout } from '@/layout/login/auth';
import useClearStorageService from '@/layout/login/hooks/useClearStorage.service';

const DisableSuccess = () => {
  const { clearLogoutStorage } = useClearStorageService();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleLogout = () => {
    clearLogoutStorage();
    dispatch(logout());
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CheckCircleIcon
          className="mx-auto mb-5 !block"
          sx={{ fontSize: 80, color: '#00C48C' }}
        />
        <Typography className="text-center" variant="h5">
          {t('tfDisableSuccessTitle')}
        </Typography>
        <Typography className="!text-pretty !my-5" variant="body2">
          {t('tfDisableSuccessDescription')}
        </Typography>
        <div className="flex justify-center gap-3">
          <Button appearance="primary" onClick={handleLogout}>
            {t('logout')}
          </Button>
        </div>
      </Grid>
    </Grid>
  );
};

export default DisableSuccess;
